import { useState } from "react";
import { MonitorCog, Power, ShieldCheck } from "lucide-react";
import type { SimulatorAppSurfaceProps } from "../AppSurface.js";

export function SystemPropertiesApp({ activeMachine, app, onRunCommand }: SimulatorAppSurfaceProps) {
  const [computerName, setComputerName] = useState(activeMachine);
  const [domainName, setDomainName] = useState("advanced-ti.local");
  const [workgroupName, setWorkgroupName] = useState("WORKGROUP");

  return (
    <div className="fd-sim-app fd-sim-system-properties">
      <section className="fd-system-tabs">
        <button className="is-active" type="button">Computer Name</button>
        <button type="button">Remote</button>
        <button type="button">Advanced</button>
      </section>
      <section className="fd-system-panel">
        <header>
          <p>{activeMachine}</p>
          <h2>System Properties</h2>
        </header>
        <div className="fd-system-summary">
          <MonitorCog size={30} />
          <div>
            <strong>{computerName}</strong>
            <small>{domainName}</small>
          </div>
        </div>
        <div className="fd-network-form-grid">
          <label>
            Computer name
            <input value={computerName} onChange={(event) => setComputerName(event.target.value)} />
          </label>
          <label>
            Domain
            <input value={domainName} onChange={(event) => setDomainName(event.target.value)} />
          </label>
          <label>
            Workgroup
            <input value={workgroupName} onChange={(event) => setWorkgroupName(event.target.value)} />
          </label>
        </div>
        <div className="fd-network-actions">
          <button
            type="button"
            onClick={() => {
              void onRunCommand({
                appId: app.id,
                commandType: "SYSTEM_RENAME_COMPUTER",
                capability: "system.identity.write",
                label: "Rename computer",
                payload: { computerName, machineId: activeMachine }
              });
            }}
          >
            <MonitorCog size={16} />
            Rename
          </button>
          <button
            type="button"
            onClick={() => {
              void onRunCommand({
                appId: app.id,
                commandType: "SYSTEM_JOIN_DOMAIN",
                capability: "domain.membership.write",
                label: "Join domain",
                payload: { controllerIp: "10.50.10.10", domainName, machineId: activeMachine, reachable: true }
              });
            }}
          >
            <ShieldCheck size={16} />
            Join domain
          </button>
          <button
            type="button"
            onClick={() => {
              void onRunCommand({
                appId: app.id,
                commandType: "SYSTEM_LEAVE_DOMAIN",
                capability: "domain.membership.write",
                label: "Set workgroup",
                payload: { machineId: activeMachine, workgroupName }
              });
            }}
          >
            Set workgroup
          </button>
          <button
            type="button"
            onClick={() => {
              void onRunCommand({
                appId: app.id,
                commandType: "RDP_ENABLE",
                capability: "remoteDesktop.write",
                label: "Enable remote access",
                payload: { enabled: true, firewallRuleName: "RDP-156", machineId: activeMachine }
              });
            }}
          >
            <Power size={16} />
            Enable remote
          </button>
        </div>
      </section>
    </div>
  );
}
